import React, { useCallback } from 'react';
import { Input } from '@/components/ui/input';
import { CanvasSize, CanvasSizeSettings } from '@/types/diagram';
import { Label } from '@/components/ui/label';

interface CanvasSettingsTabProps {
    canvas: CanvasSizeSettings;
    onChange: {
        (key: 'canvasSize', value: CanvasSize): void;
        (key: 'showAttachmentPoints', value: boolean): void;
    };
}

export const CanvasSettingsTab: React.FC<CanvasSettingsTabProps> = ({
    canvas,
    onChange,
}) => {
    const handleCanvasSizeChange = useCallback((sizePartial: Partial<CanvasSize>): void => {
        const newCanvasSize = { ...canvas.canvasSize, ...sizePartial };
        onChange('canvasSize', newCanvasSize);
    }, [canvas.canvasSize, onChange]);

    const handleAttachmentPointsChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        onChange('showAttachmentPoints', event.target.checked);
    }, [onChange]);

    return (
        <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <Label className="block text-sm font-medium text-white mb-1">
                        Width
                    </Label>
                    <Input
                        type="number"
                        value={canvas.canvasSize.width}
                        onChange={(e) => handleCanvasSizeChange({ width: parseInt(e.target.value) })}
                        min={1}
                        className="bg-surface-input border-surface-border text-white"
                    />
                </div>
                <div>
                    <Label className="block text-sm font-medium text-white mb-1">
                        Height
                    </Label>
                    <Input
                        type="number"
                        value={canvas.canvasSize.height}
                        onChange={(e) => handleCanvasSizeChange({ height: parseInt(e.target.value) })}
                        min={1}
                        className="bg-surface-input border-surface-border text-white"
                    />
                </div>
            </div>
            <div className="flex items-center space-x-2">
                <input
                    type="checkbox"
                    id="show-attachment-points"
                    checked={canvas.showAttachmentPoints}
                    onChange={handleAttachmentPointsChange}
                    className="rounded border-surface-border bg-surface-input text-primary focus:ring-primary"
                />
                <Label htmlFor="show-attachment-points" className="text-sm text-white">
                    Show Attachment Points
                </Label>
            </div>
        </div>
    );
};